import $ from 'jquery';
import Variables from './Variables';

const Utility = (() => {
  return {
    initialize: () => {
      const $html = $('html');
      const $head = $('head');
      if ($head.length > 0) {
        $(`<style type="text/css">.scrollbar-offset{padding-right:${Variables.scrollbarWidth}px!important;}</style>`)
          .appendTo($head);
      }
      if (Utility.isInternetExplorer()) {
        $html.addClass('ie');
      }
    },
    getViewport: () => {
      let e = window, a = 'inner';
      if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
      }
      return {width: e[a + 'Width'], height: e[a + 'Height']};
    },
    doesUrlExist: (url, callback) => {
      if (typeof callback === 'undefined' || callback === null) {
        return;
      }
      $.ajax({
        type: 'HEAD',
        url,
        success() {
          callback(true);
        },
        error() {
          callback(false);
        },
      });
    },
    isBrowser: () => typeof navigator.plugins !== 'undefined' && navigator.plugins.length > 0,
    cleanSelector: selector => (typeof selector !== 'undefined' ?
        selector.toString()
          .replace(/([:.[])/g, '\\$1')
        : ''
    ),
    getUrlFilename: (url) => {
      if (url) {
        const m = url.toString()
          .match(/.*\/(.+?)\./);
        if (m && m.length > 1) {
          return m[1];
        }
      }
      return '';
    },
    isTouchDevice: () => {
      try {
        document.createEvent('TouchEvent');
        return true;
      } catch (e) {
        return false;
      }
    },
    getJSON: (str) => {
      if (typeof (str) === 'object') {
        return str;
      }
      return JSON.parse(str);
    },
    isJSONString: (str) => {
      try {
        if (typeof (str) === 'object') {
          return true;
        }
        if (typeof (str) === 'string') {
          if (str.length === 0) {
            return false;
          }
        }
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    isInternetExplorer: () =>
      !!navigator.userAgent.match(/Trident/g) ||
      !!navigator.userAgent.match(/MSIE/g) ||
      /* @cc_on!@ */false,
    getCaretPosition: ($element) => {
      let position = 0;
      const element = $element.get(0);
      if (document.selection) {
        element.focus();
        const range = document.selection.createRange();
        range.moveStart('character', -element.value.length);
        position = range.text.length;
      } else if (element.selectionStart || element.selectionStart === 0) {
        position = element.selectionStart;
      }
      return position;
    },
    setCaretPosition: ($element, position) => {
      const element = $element.get(0);
      if (element.setSelectionRange) {
        element.focus();
        element.setSelectionRange(position, position);
      } else if (element.createTextRange) {
        const range = element.createTextRange();
        range.collapse(true);
        range.moveEnd('character', position);
        range.moveStart('character', position);
        range.select();
      }
    },
    replaceAt: (string, replacement, index) => string.substr(0, index)
      + replacement + string.substr(index + replacement.length),
    arrayContains: (arr, obj) => {
      let i = arr.length;
      while (i--) {
        if (arr[i] === obj) {
          return true;
        }
      }
      return false;
    },
    getUrlParameter(name) {
      const url = window.location.href;
      name = name.replace(/[[\]]/g, '\\$&');
      const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
      const results = regex.exec(url);
      if (!results) {
        return null;
      }
      if (!results[2]) {
        return '';
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    addEventOnce(target, type, fn, args) {
      const wrapperFn = () => {
        fn();
        this.removeEvent(target, type, fn, args);
      };
      this.addEvent(target, type, wrapperFn, args);
    },
    addEvent(target, type, fn, args) {
      if (target.attachEvent) {
        target.attachEvent(`on${type}`, fn);
      } else {
        target.addEventListener(type, fn, args);
      }
    },
    removeEvent(target, type, fn, args) {
      if (target.detachEvent) {
        target.detachEvent(`on${type}`, fn);
      } else {
        target.removeEventListener(type, fn, args);
      }
    },
  };
})();

export default Utility;



// WEBPACK FOOTER //
// ./scripts/App/Utility.js